<template>
  <div>
    <van-popup
      v-model="isView"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#fff' }"
    >
      <div>
        <van-nav-bar fixed>
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
          <div slot="title">筛选</div>
        </van-nav-bar>
        <div class="search-wrap">
          <div class="search-wrap-card">
            <div class="search-wrap-card-label">时间筛选</div>
            <div class="search-wrap-card-flex">
              <span class="search-time van-hairline--surround" @click="startDateBtn">{{startDateChange}}</span>
              <span class="search-time-line">-</span>
              <span class="search-time van-hairline--surround" @click="endDateBtn">{{endDateChange}}</span>
            </div>
          </div>
          <div class="search-wrap-card">
            <div class="search-wrap-card-label">公文状态</div>
            <div class="search-wrap-card-flex">
              <span
                class="search-wrap-card-flex-btn"
                v-for="item in statusList"
                :key="item.statusID"
                :class="item.statusID===isStatusID?'active':''"
                @click="changeStatus(item)">{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="search-footer">
        <div class="cancel" @click="close">取消</div>
        <div class="submit" @click="submitSearch">确定</div>
      </div>
    </van-popup>
    <van-popup
      v-model="isStartDate"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }">
        <van-datetime-picker
            v-model="startDate"
            @confirm="startDateOk"
            cancel-button-text="重置"
            @cancel="startDateCancel"
            type="date"
          />
      </van-popup>
      <van-popup
      v-model="isEndDate"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }">
        <van-datetime-picker
            v-model="endDate"
            @confirm="endDateOk"
            cancel-button-text="重置"
            @cancel="endDateCancel"
            type="date"
          />
      </van-popup>
  </div>
</template>
<script>
export default {
  name: "Search",
  props: {
    isView: Boolean,
    statusList:Array
  },
  data() {
    return {
      isStatusID:0,
      isStartDate:false,
      isEndDate:false,
      startDate:new Date(),
      endDate:new Date(),
      startDateChange:'开始时间',
      endDateChange:'结束时间'
    }
  },
  watch: {
    rows: {
      handler(val) {
        if (val) {
          this.buildRow = val;
        }
      },
      deep: true
    },
    immediate: true
  },
  methods: {
    changeStatus(val){
      this.isStatusID=val.statusID
    },
    startDateBtn(){
      this.isStartDate=true
    },
    startDateOk(val){
      this.isStartDate=false
      this.startDateChange=this.xy.moment(val).format("YYYY/MM/DD")
    },
    startDateCancel(){
      this.isStartDate=false
      this.startDateChange='开始时间'
    },
    endDateBtn(){
      this.isEndDate=true
    },
    endDateOk(val){
      this.isEndDate=false
      this.endDateChange=this.xy.moment(val).format("YYYY/MM/DD")
    },
    endDateCancel(){
      this.isEndDate=false
      this.endDateChange='结束时间'
    },
    close() {
      this.$emit("listenToChildClose", false);
    },
    submitSearch(){
      if(this.diff(this.startDateChange, 'd', this.endDateChange) < 0){
        this.xy.msgError('开始时间不能大于结束时间')
      }else{
        let option={
          startDateChange:this.startDateChange==='开始时间'?'':this.startDateChange,
          endDateChange:this.endDateChange==='结束时间'?'':this.endDateChange,
          statusID:this.isStatusID
        }
        this.$emit("listenToChildCSubmit", option);
      }
    },
    diff(date, strInterval, dtEnd) {
      if (typeof dtEnd === "string") {
        //如果是字符串转换为日期型
        dtEnd = new Date(dtEnd.replace(/-/g, "/")); //StringToDate(dtEnd);
      }
      if (typeof date === "string") {
        //如果是字符串转换为日期型
        date = new Date(date.replace(/-/g, "/")); //StringToDate(dtEnd);
      }
      switch (strInterval) {
        case "s":
          return parseInt((dtEnd - date) / 1000);
        case "n":
          return parseInt((dtEnd - date) / 60000);
        case "h":
          return parseInt((dtEnd - date) / 3600000);
        case "d":
          return parseInt((dtEnd - date) / 86400000);
        case "w":
          return parseInt((dtEnd - date) / (86400000 * 7));
        case "m":
          return (
            dtEnd.getMonth() +
            1 +
            (dtEnd.getFullYear() - date.getFullYear()) * 12 -
            (date.getMonth() + 1)
          );
        case "y":
          return dtEnd.getFullYear() - date.getFullYear();
      }
    },
  }
};
</script>
<style lang="less" scoped>
.search-wrap{
  margin-top: 110px;
  margin-left:38px;
  .search-wrap-card{
    margin-bottom:100px;
    .search-wrap-card-label{
      font-size:30px;
      margin:38px 0;
    }
    .search-time-line{
      margin:0 10px;
    }
    .search-time{
      padding:16px 30px;
    }
    .search-wrap-card-flex{
      display: flex;
      flex-wrap:wrap;
      align-items: center;
      .search-wrap-card-flex-btn{
        width:184px;
        height:66px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius:8px;
        margin:0 40px 40px 0;
        border:1px solid #ebedf0;
      }
      .search-wrap-card-flex-btn.active{
        border-color: #4196ff;
        color:#4196ff;
      }
    }
  }
}
.search-footer{
  position: fixed;
  bottom:0;
  left:0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding:20px;
  div{
    width:346px;
    height:88px;
    border-radius: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:30px;
  }
  .cancel{
    color:#267DFF;
    background:rgba(255,255,255,1);
    border:1px solid rgba(38,125,255,1);
  }
  .submit{
    color:#fff;
    background:rgba(41,128,254,1);
  }
}
</style>
